module.exports = __webpack_public_path__ + "static/media/Rancagua.4c0a5467.png";